import { Component, Input, OnInit } from '@angular/core';
import { Business } from '../models/business.model';
import { loadTags } from '../../util/tag-utils';
import { IConditionalSection } from '../../shared/models/condition-section.model';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditTagsComponent } from '../../shared/edit-tags/edit-tags.component';
import {BusinessManagerService} from '../../shared/user/business-manager.service';


@Component({
  selector: 'app-business-sales',
  templateUrl: './business-sales.component.html',
  styleUrls: ['./business-sales.component.scss']
})
export class BusinessSalesComponent implements OnInit, IConditionalSection {
  @Input() business: Business;
  aircraftSalesTypesTags: String[] = [];
  aircraftTags: String[] = [];
  avionicsTags: String[] = [];
  editModeSet = false;
  isRegionalManager = false;

  constructor(private _toggleService: EditToggleService,
              private _editSalesCheckboxDialog: MatDialog,
              public snackBar: MatSnackBar,
              private _businessManagerService: BusinessManagerService) {
    this._toggleService.toggleEmitter.subscribe(isOn => {
      this.editModeSet = isOn;
    });
  }

  async ngOnInit() {
    this.loadAllTags();
    this.isRegionalManager = await this._businessManagerService.isRegionalManager()
      && !await this._businessManagerService.userOwnsBusiness(this.business.id);
  }

  loadAllTags() {
    this.aircraftSalesTypesTags = loadTags(this.business.tags, 'Sales::Types::', '', '');
    this.aircraftTags = loadTags(this.business.tags, 'Sales::Aircraft::', '', '');
    this.avionicsTags = loadTags(this.business.tags, 'Sales::Avionics::', '', '');
  }

  get hasContent(): boolean {
    return (this.aircraftSalesTypesTags.length > 0 || this.aircraftTags.length > 0 || this.avionicsTags.length > 0);
  }

  openEditSalesDialog(group: String[], except: String[], title: string): void {
    const dialogConfig = new MatDialogConfig();
    const ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;

    dialogConfig.data = {
      business: this.business,
      tagsGroup: group,
      except: except,
      title: title
    };

    dialogConfig.width = '95%';
    const dialogRef = this._editSalesCheckboxDialog.open(EditTagsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((isSuccess) => {
      if (isSuccess) {
        this.loadAllTags();
      } else {
        this.snackBar.open(ERROR_MSG, 'Error', {
          duration: 6000
        });
      }
    });
  }
}
